import React, { useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Input, Modal, Select, Form } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { toast } from 'react-toastify';
import {
	useGetObserversQuery,
	usePostCustomDashboardMutation
} from 'src/redux/services/centralApi';

interface IAddCustomDashboardForm {
	name: string;
	roles: string[];
	observers: string[];
}

export default function AddCustomDashboard() {
	const [ open, setOpen, ] = useState(false);
	const [ form, ] = useForm<IAddCustomDashboardForm>();
	const { data: observersData, isLoading: isLoadingObserversData, } =
        useGetObserversQuery();
	const [ postCustomDashboard, ] =
        usePostCustomDashboardMutation();

	return (
		<>
			<Button
				type='primary'
				onClick={() => {
					setOpen(true);
				}}
				icon={<PlusOutlined />}
			>
                Adicionar
			</Button>
			<Modal
				centered
				title={'Cadastrar Novo Conjunto de Indicadores'}
				open={open}
				onCancel={() => {
					setOpen(false);
					toast.info('Operação cancelada!', { autoClose: 1000, });
				}}
				destroyOnHidden
				okText='Cadastrar'
				onOk={() => {
					form.validateFields().then((values) => {
						postCustomDashboard({
							name: values.name,
							roles: { roles: values.roles, },
							layout: [],
							observer_ids: values.observers,
						})
							.unwrap()
							.then(() => {
								toast.success(
									'Conjunto de indicadores cadastrado com sucesso!',
									{ autoClose: 1000, }
								);
							})
							.catch(() => {
								toast.error(
									'Erro ao cadastrar o conjunto de indicadores!',
									{ autoClose: 1000, }
								);
							})
							.finally(() => {
								setOpen(false);
							});
					});
				}}
				confirmLoading={false}
			>
				<Form form={form} layout='vertical'>
					<Form.Item
						label='Nome'
						name='name'
						rules={[
							{
								required: true,
								message: 'Por favor, informe o nome!',
							},
							{
								max: 100,
								message:
                                    'O nome não pode ter mais que 100 caracteres!',
							},
							{
								min: 3,
								message:
                                    'O nome não pode ter menos que 3 caracteres!',
							},
						]}
					>
						<Input placeholder='Digite o nome aqui...' />
					</Form.Item>
					<Form.Item
						label='Observadores Atrelados'
						name='observers'
						hasFeedback
						rules={[
							{
								required: true,
								message:
                                    'Por favor, informe os observadores atrelados!',
							},
						]}
					>
						<Select
							mode='multiple'
							placeholder='Observadores...'
							options={(observersData ?? []).map((el) => ({
								label: el.name,
								value: el.observer_id,
							}))}
							loading={isLoadingObserversData}
						/>
					</Form.Item>
					<Form.Item
						label='Perfis de Acesso'
						name='roles'
						hasFeedback
						rules={[
							{
								required: true,
								message:
                                    'Por favor, informe os perfis de acesso!',
							},
						]}
					>
						<Select
							mode='multiple'
							placeholder='Perfis de acesso...'
							options={[
								{ label: 'Usuário', value: 'user', },
								{ label: 'Administrador', value: 'admin', },
								{ label: 'Parceiro', value: 'partner', },
							]}
						/>
					</Form.Item>
				</Form>
			</Modal>
		</>
	);
}
